// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-raised-button.mat-blue {
  background-color: #5479b9;
  color: white;
}

.mat-mdc-raised-button.mat-gray {
  background-color: #c7c7c7;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/rename-modal/rename-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF","sourcesContent":[".mat-mdc-raised-button.mat-blue {\r\n  background-color: #5479b9;\r\n  color: white;\r\n}\r\n\r\n.mat-mdc-raised-button.mat-gray {\r\n  background-color: #c7c7c7;\r\n  color: white;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
